import { render, staticRenderFns } from "./ManualProduct.vue?vue&type=template&id=04a45db0&scoped=true"
import script from "./ManualProduct.vue?vue&type=script&lang=js"
export * from "./ManualProduct.vue?vue&type=script&lang=js"
import style0 from "./ManualProduct.vue?vue&type=style&index=0&id=04a45db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a45db0",
  null
  
)

export default component.exports